import request from '@/utils/request'

export function getSourceListApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group/source',
    method: 'get',
    params: query
  })
}
